// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-o_fP","advertDetailHeaderPrice__value":"c-o_fQ","advertDetailHeaderPrice__label":"c-o_fR"};